/*!
 *
 * Angle - Bootstrap Admin Template
 *
 * Version: 4.7.1
 * Author: @themicon_co
 * Website: http://themicon.co
 * License: https://wrapbootstrap.com/help/licenses
 *
 */

import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";

// App Routes
import MainRoutes from "./Routes/index";

// Vendor dependencies
import "./Vendor";
// Application Styles
import "./styles/bootstrap.scss";
import "./styles/app.scss";

class App extends Component {
  render() {
    // specify base href from env varible 'PUBLIC_URL'
    // use only if application isn't served from the root
    // for development it is forced to root only
    /* global PUBLIC_URL */
    const basename =
      //process.env.NODE_ENV === "development" ? "/" : "PUBLIC_URL" || "/";
      process.env.NODE_ENV === "development" ? "/" : "/" || "/";

    return (
      
        <MainRoutes />
      
    );
  }
}

export default App;
